/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./radio.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/forms";
import * as i3 from "./radio-group.component";
var styles_UIRadioGroupComponent = [i0.styles];
var RenderType_UIRadioGroupComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UIRadioGroupComponent, data: {} });
export { RenderType_UIRadioGroupComponent as RenderType_UIRadioGroupComponent };
export function View_UIRadioGroupComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_UIRadioGroupComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 3, "ui-radio-group", [], null, null, null, View_UIRadioGroupComponent_0, RenderType_UIRadioGroupComponent)), i1.ɵprd(5120, null, i2.NG_VALUE_ACCESSOR, function (p0_0) { return [p0_0]; }, [i3.UIRadioGroupComponent]), i1.ɵdid(2, 1228800, null, 1, i3.UIRadioGroupComponent, [], null, null), i1.ɵqud(603979776, 1, { radios: 1 })], null, null); }
var UIRadioGroupComponentNgFactory = i1.ɵccf("ui-radio-group", i3.UIRadioGroupComponent, View_UIRadioGroupComponent_Host_0, { disabled: "disabled", name: "name" }, {}, ["*"]);
export { UIRadioGroupComponentNgFactory as UIRadioGroupComponentNgFactory };
